import { render } from "./LocationFiles.vue?vue&type=template&id=455b58c2&scoped=true"
import script from "./LocationFiles.vue?vue&type=script&lang=js"
export * from "./LocationFiles.vue?vue&type=script&lang=js"

import "./LocationFiles.vue?vue&type=style&index=0&id=455b58c2&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455b58c2"]])

export default __exports__